/*
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T21:47:30+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-05-11T13:30:16+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Filter to Transfer a value into a currency formatted string

Use:
  {{ 10.63 | formatCurrency('usd', 1.15) }}

To make it look nice, rounded on .05 :
  {{ 10.63 | formatCurrency('eur', 1.00, true) }}

*/

import Vue from 'vue'

export default function formatCurrency (value, locCurr = 'eur', locRate = 1.00, nice = false) {
  console.log(`Using currency rate: €1,00 == ${locRate} ${locCurr}`)

  let convertedValue = value * locRate
  if (nice) {
    convertedValue = (0.05 * convertedValue).toFixed(2) / 0.05 - 0.05
    convertedValue = (convertedValue < 0) ? 0 : convertedValue
  }

  return convertedValue.toLocaleString(Vue.config.lang, {
    style: 'currency',
    currency: locCurr.toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).trim()
}
